const skills = [{
  title: 'Programming Language',
  children: [
    {
      title: 'JavaScript',
      value: 90
    },
    {
      title: 'Java (Spring Boot)',
      value: 70
    },
    {
      title: 'Python',
      value: 30
    },
    {
      title: 'Kotlin',
      value: 30
    }
  ]
},
{
  title: 'Javascript Framework',
  children: [
    {
      title: 'React JS (V17 hooks)',
      value: 90
    },
    {
      title: 'React Native',
      value: 40
    },
    {
      title: 'Vue.js',
      value: 60
    },
    {
      title: 'Node.js',
      value: 80
    },
    {
      title: 'AngularJS',
      value: 30
    },
    {
      title: 'jQuery',
      value: 70
    }
  ]
},
{
  title: 'CSS Framework',
  children: [
    {
      title: 'Bulma',
      value: 70
    },
    {
      title: 'Bootstrap',
      value: 80
    },
    {
      title: 'Material Design',
      value: 40
    }
  ]
},
{
  title: 'Database',
  children: [
    {
      title: 'Microsoft SQL Server',
      value: 70
    },
    {
      title: 'MySQL Server',
      value: 70
    },
    {
      title: 'Amazon Dynamodb',
      value: 40
    },
    {
      title: 'Realm',
      value: 30
    }
  ]
},
{
  title: 'Test',
  children: [
    {
      title: 'React Testing Library',
      value: 70
    },
    {
      title: 'Jest',
      value: 70
    },
    {
      title: 'Nightwatch.js',
      value: 30
    },
    {
      title: 'Enzyme',
      value: 40
    },
    {
      title: 'JMeter',
      value: 30
    }
  ]
},
{
  title: 'Continues Integration',
  children: [
    {
      title: 'Jenkins',
      value: 60
    },
    {
      title: 'CircleCI',
      value: 60
    },
    {
      title: 'AWS CodeDeploy',
      value: 40
    },
    {
      title: 'Gitlab Pipeline',
      value: 30
    }
  ]
},
{
  title: 'Other',
  children: [
    {
      title: 'ECMA Script',
      value: 80
    },
    {
      title: 'Rollup + Lerna (Creating react component library)',
      value: 70
    },
    {
      title: 'Amazon Web Services (AWS)',
      value: 70
    },
    {
      title: 'Github/Gitlab',
      value: 80
    },
    {
      title: 'Docker',
      value: 70
    },
    {
      title: 'Pug/SCSS',
      value: 80
    },
    {
      title: 'Webpack',
      value: 60
    },
    {
      title: 'Gulp',
      value: 40
    },
    {
      title: 'Linux commands',
      value: 70
    },
    {
      title: 'Responsive webdesign',
      value: 85
    }
  ]
}]

export default skills
